import { FC } from 'react'

import styled from 'styled-components'
import { ComboboxItem } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'

import { colors } from 'src/Helpers/constants.ts'
import { Button } from 'src/Components/Button'
import { OfferModelUnit } from 'src/Pages/Calculator/useCalculator.tsx'

import { UnitItem } from './UnitItem'

const UnitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 12px 0 0;
  border-top: 1px dashed ${colors.secondGray};
  margin-top: 12px;
  align-items: center;
`

const StyledButton = styled(Button)`
  max-width: 200px;
`

const UnitsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  align-items: center;
`

interface UnitsListProps {
  units: OfferModelUnit[]
  tools: { label: string; value: string }[]
  onAddUnit: () => void
  onRemoveUnit: (unitIndex: number) => void
  onUpdateUnit: <T extends keyof OfferModelUnit>(
    unitIndex: number,
    property: T,
    value: OfferModelUnit[T],
  ) => void
}

export const UnitsList: FC<UnitsListProps> = ({
  units,
  tools,
  onAddUnit,
  onRemoveUnit,
  onUpdateUnit,
}) => {
  const canDelete = units.length > 1

  return (
    <UnitsContainer data-testid='units-list'>
      <UnitsContent>
        {units.map((unit, index) => (
          <UnitItem
            key={index}
            unit={unit}
            unitIndex={index}
            canDelete={canDelete}
            tools={tools}
            onDeparturePointChange={(value) =>
              onUpdateUnit(index, 'departurePoint', value)
            }
            onWorkPointChange={(value) =>
              onUpdateUnit(index, 'workPoint', value)
            }
            onReturnPointChange={(value) =>
              onUpdateUnit(index, 'returnPoint', value)
            }
            onDeliveryCostChange={(value) =>
              onUpdateUnit(index, 'deliveryCost', value)
            }
            onReturnCostChange={(value) =>
              onUpdateUnit(index, 'returnCost', value)
            }
            onQuantityChange={(value) => onUpdateUnit(index, 'quantity', value)}
            onShiftCountChange={(value: string | null, _option: ComboboxItem) =>
              onUpdateUnit(
                index,
                'shiftCount',
                value ? Number(value) : undefined,
              )
            }
            onToolChange={(value: string | null, _option: ComboboxItem) =>
              onUpdateUnit(index, 'toolId', value ? Number(value) : undefined)
            }
            onDelete={() => onRemoveUnit(index)}
          />
        ))}

        <StyledButton
          variant='light'
          leftSection={<IconPlus size={16} />}
          onClick={onAddUnit}
          data-testid='add-unit-button'
        >
          Добавить единицу техники
        </StyledButton>
      </UnitsContent>
    </UnitsContainer>
  )
}
